import React, { useState, useEffect } from 'react';
import axios from 'axios';

const FeaturedManager = ({ products, onClose, onUpdate }) => {
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Get currently featured products
    const featured = products.filter(p => p.featured).map(p => p.id);
    setSelectedProducts(featured);
  }, [products]);

  const handleProductToggle = (productId) => {
    setSelectedProducts(prev => {
      if (prev.includes(productId)) {
        return prev.filter(id => id !== productId);
      } else if (prev.length < 3) {
        return [...prev, productId];
      }
      return prev; // Don't add if already at limit
    });
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/admin/featured`, {
        productIds: selectedProducts
      });
      alert(`${selectedProducts.length} products set as featured!`);
      onUpdate();
      onClose();
    } catch (error) {
      console.error('Error setting featured products:', error);
      alert('Failed to update featured products');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        maxWidth: '800px',
        width: '90%',
        maxHeight: '80vh',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <div style={{ padding: '2rem 2rem 1rem 2rem', borderBottom: '1px solid #eee' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
            <h3 style={{ margin: 0 }}>Manage Featured Products</h3>
            <button 
              onClick={onClose}
              style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer' }}
            >
              ×
            </button>
          </div>
          
          <p style={{ color: '#666', margin: 0 }}>
            Select up to 3 products to feature on the home page. Currently selected: {selectedProducts.length}/3
          </p>
        </div>

        <div style={{ flex: 1, overflowY: 'auto', padding: '1rem 2rem' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: '1rem' }}>
          {products.map(product => (
            <div 
              key={product.id}
              onClick={() => handleProductToggle(product.id)}
              style={{
                border: selectedProducts.includes(product.id) ? '2px solid var(--primary-saffron)' : '1px solid #ddd',
                borderRadius: '8px',
                padding: '1rem',
                cursor: selectedProducts.includes(product.id) || selectedProducts.length < 3 ? 'pointer' : 'not-allowed',
                backgroundColor: selectedProducts.includes(product.id) ? '#fff3e0' : 'white',
                opacity: selectedProducts.includes(product.id) || selectedProducts.length < 3 ? 1 : 0.5,
                transition: 'all 0.2s'
              }}
            >
              {product.image && (
                <img 
                  src={product.image} 
                  alt={product.name}
                  style={{ width: '100%', height: '120px', objectFit: 'cover', borderRadius: '6px', marginBottom: '0.5rem' }}
                />
              )}
              <h4 style={{ margin: '0 0 0.5rem 0', fontSize: '1rem' }}>{product.name}</h4>
              <p style={{ margin: '0 0 0.5rem 0', color: '#666', fontSize: '0.875rem' }}>
                {product.category} • S${product.price?.toFixed(2)}
              </p>
              {selectedProducts.includes(product.id) && (
                <div style={{ 
                  backgroundColor: 'var(--primary-saffron)', 
                  color: 'white', 
                  padding: '0.25rem 0.5rem', 
                  borderRadius: '4px', 
                  fontSize: '0.75rem',
                  display: 'inline-block'
                }}>
                  Featured
                </div>
              )}
            </div>
          ))}
          </div>
        </div>

        <div style={{ padding: '1rem 2rem', borderTop: '1px solid #eee', backgroundColor: '#f8f9fa' }}>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>
            <button 
              onClick={onClose}
              className="btn btn-outline"
            >
              Cancel
            </button>
            <button 
              onClick={handleSave}
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? 'Saving...' : `Set ${selectedProducts.length} Featured Products`}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturedManager;